import { EmptyState } from "@/components/shared/empty-state";
import type { CreatorStat, TokenMetadatum } from "@/graphql/codegen/graphql";

import { TimePeriod } from "../../discover-sort-constants";
import { DiscoverWidgetUserRow } from "./discover-widget-user-row";
import { DiscoverWidgetUserRowSkeleton } from "./discover-widget-user-row-skeleton";
import { WidgetPreset } from "./sidebar-top-results-widget-time-period";
import { useDiscoverWidgetQuery } from "./use-discover-widget-query";

export const TopEarnersWidgetView = ({
  preset = WidgetPreset.topEarners,
  selectedTimePeriod = TimePeriod.AllTime,
  baseRedirectUrl,
}: {
  preset?: WidgetPreset;
  selectedTimePeriod?: TimePeriod;
  baseRedirectUrl?: string;
  onRowClick?: (username: string) => void;
}) => {
  const { initialLoading, items, loadingMarkup } = useDiscoverWidgetQuery({
    preset,
    timePeriod: selectedTimePeriod,
  });
  const creators = items as Array<CreatorStat | TokenMetadatum>;

  return (
    <div className="flex w-full flex-col items-start justify-between">
      {!initialLoading && creators.length === 0 && (
        <div className="flex size-full items-center justify-center p-2 py-4">
          <EmptyState
            image="/assets/empty-31.png"
            title="No results."
            description="Try adjusting the filters."
          />
        </div>
      )}

      <div
        className="
          custom-scrollbar custom-scrollbar-hover-only h-[400px] w-full
        "
      >
        {creators.map((creator) => (
          <DiscoverWidgetUserRow
            key={creator.publicKeyBase58Check}
            user={creator}
            preset={preset}
            selectedTimePeriod={selectedTimePeriod}
            baseRedirectUrl={baseRedirectUrl}
          />
        ))}
        {initialLoading ? (
          <DiscoverWidgetUserRowSkeleton count={10} />
        ) : (
          loadingMarkup
        )}
      </div>
    </div>
  );
};
